import { Input } from '@arco-design/web-react'
import { SENSITIVE_PLACEHOLDER } from './optionKeys'

interface Props {
  value: string
  onChange: (value: string) => void
  placeholder?: string
  /** 用户是否在本会话编辑过（有非空草稿） */
  showConfiguredHint?: boolean
}

/** 敏感 option 字段：GET 不返回值，留空保存时不覆盖后端已有配置 */
export default function SensitiveInput({
  value,
  onChange,
  placeholder,
  showConfiguredHint = true,
}: Props) {
  const hint =
    placeholder ??
    (showConfiguredHint && !value.trim() ? SENSITIVE_PLACEHOLDER : undefined)

  return (
    <Input.Password
      value={value}
      onChange={onChange}
      placeholder={hint}
      autoComplete="new-password"
    />
  )
}
